import { SecurityWithRank } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityRanking/securityRankingTypes.ts';

export const makeSecurityRankId = (security: SecurityWithRank) =>
	`${security.securityId}-${security.securityFeatureType}`;

export { getSecurityFeatureTypeColors } from '@dealstack/frontend/shared/components/SecurityRankCard/securityFeatureTypeColors.ts';
